import React, { useEffect, useState } from "react";
import { Loader } from "@vds/loaders";
import { connect } from "react-redux";
import styled from "styled-components";
import Tick from "../../assets/icons/tickSymbol.png";
import Caution from "../../assets/icons/caution.png";
import * as CaseAttachemntCall from "../../api/cases/index";
import * as viewCaseDetailsActions from "../../store/actions/cases/viewCaseDetailsActions";
import * as GlobalActions from "../../store/actions/global/global";
import { useTranslation } from "react-i18next";
import { CPButton, CustomisedTertiaryButton, CustomLoader, TextWrapper } from "../../constants/common/StyledGlobalConstants";
import RedesignedModal from "../common/RedesignedModal";
import "../common/RedesignedModal.css";
import PropTypes from "prop-types";

const breakPoint = 480;

const Wrapper = styled.div`
  display: ${(props) => (props.display ? props.display : "")};
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "")};
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : "")};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  background: ${(props) => (props.background ? props.background : "")};
  color: ${(props) => (props.fontColor ? props.fontColor : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  height: ${(props) => (props.height ? props.height : "")};
  width: ${(props) => (props.width ? props.width : "")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "")};
  min-width: ${(props) => (props.minWidth ? props.minWidth : "")};
  gap: ${(props) => (props.gap ? props.gap : "")};
`;

const AddAttachmentTryAgain = (props) => {
  const [filesToBeUploaded, setFilesToBeUploaded] = useState([]);
  const [filePostData, setFilePostData] = useState([]);
  const [attachmentLoaderSmall, setAttachmentLoaderSmall] = useState(false);
  const [fileStatusResponse, setFileStatusResponse] = useState([]);
  const [fileSuccessAndError, setFileSuccessAndError] = useState([]);
  const [disableCancelButton, setDisableCancelButton] = useState(false);
  const [fileStatusAgain, setFileStatusAgain] = useState([]);
  const { t } = useTranslation("casesTranslation");

  useEffect(() => {
    if (props.filesToBeUploaded.length) setFilesToBeUploaded(props.filesToBeUploaded);
  }, [props.filesToBeUploaded]);

  useEffect(() => {
    if (filePostData.length) {
      handleAttachmentsCall();
    }
  }, [filePostData]);

  useEffect(() => {
    return () => {
      props.setAttachmentStatusResponse([]);
      props.setAttachmentName([]);
      setAttachmentLoaderSmall(false);
      setFilesToBeUploaded([]);
      setFilePostData([]);
      setFileStatusResponse([]);
      setFileSuccessAndError([]);
      setFileStatusAgain([]);
      props.setCaseNumberGlobal("");
      if (props.addCommentTryAgain === true) {
        props.getActivity();
      }
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    let fileResponse = [];
    if (fileStatusResponse.length) {
      fileStatusResponse.forEach((fStatus) => (fStatus.status === "fulfilled" ? fileResponse.push("true") : fileResponse.push("false")));
      setFileSuccessAndError([...fileResponse]);
      setFileStatusAgain([...fileResponse]);
    }
  }, [fileStatusResponse]);

  useEffect(() => {
    if (fileStatusAgain.length) {
      const fileStatus = fileStatusAgain.map((val, index) => {
        return {
          status: val,
          fname: filesToBeUploaded[index].name,
        };
      });

      handleFilesAfterTryAgain(fileStatus);
    }
  }, [fileStatusAgain]);

  useEffect(() => {
    let flag = false;
    if (fileSuccessAndError.length) {
      for (const val of fileSuccessAndError) {
        if (val === "false") {
          flag = true;
          props.setFileTryAgainModal(true);
          break;
        }
      }
      if (flag === false) {
        props.setFileTryAgainModal(false);
        props.setFileTryAgainSuccess(true);
        setFileSuccessAndError([]);
        setTimeout(function () {
          props.setFileTryAgainSuccess(false);
        }, 5000);
      }
      // setShowModal(!fileSuccessAndError.every((val,i,arr) => val === arr[0]))
    }
  }, [fileSuccessAndError]);

  const handleFilesAfterTryAgain = (fileStatus) => {
    let onlySuccess = [...fileSuccessAndError];
    let fname = [];
    for (let index = fileStatus.length - 1; index >= 0; index--) {
      if (fileStatus[index].status === "true") {
        fname.push(fileStatus[index].fname);
        onlySuccess.splice(index, 1);
      }
    }
    handleDeleteSuccessFiles([...fname]);
    setFileSuccessAndError([...onlySuccess]);
  };

  const handleDeleteSuccessFiles = (fname) => {
    if (fname.length) {
      let res = filesToBeUploaded.filter((file) => !fname.includes(file.name));
      setFilesToBeUploaded(res);
    }
  };

  const handleFileUploadAgain = async () => {
    let newFiles = [];
    if (filesToBeUploaded.length) {
      setFileSuccessAndError([]);
      for (const file of filesToBeUploaded) {
        let base64ConvertedFile = await convertBase64(file);
        let splitData = base64ConvertedFile.split(",");
        let fileName = file.name;
        let fileTitle = handleGetOnlyFileName(fileName);
        let postData = {
          caseId: props.addCommentCaseId ? props.addCommentCaseId : props.caseIdGlobal,
          visibility: "AllUsers",
          title: fileName,
          fileName: fileTitle,
          isMajorVersion: "true",
          versionData: splitData[1],
        };
        newFiles.push(postData);
      }
      setFilePostData([...newFiles]);
    }
  };

  const handleAttachmentsCall = () => {
    const tasks = filePostData.map((fData) => CaseAttachemntCall.postAnAttachmentCall(fData));

    if (tasks.length !== 0) {
      setAttachmentLoaderSmall(true);
      setDisableCancelButton(true);
      Promise.allSettled(tasks)
        .then((res) => {
          setAttachmentLoaderSmall(false);
          setDisableCancelButton(false);
          setFileStatusResponse(res);
        })
        .catch((err) => {
          setAttachmentLoaderSmall(false);
          setDisableCancelButton(false);
          console.log("Error", err);
        });
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(new Error(error?.message || "Error converting file to base64"));
      };
    });
  };

  const handleGetOnlyFileName = (fileName) => {
    let lastDotPosition = fileName.lastIndexOf(".");
    if (lastDotPosition === -1) {
      return fileName;
    } else {
      return fileName.substr(0, lastDotPosition);
    }
  };

  const getModalTitle = () => {
    const isMultipleFiles = filesToBeUploaded.length > 1;

    if (props.addCommentTryAgain) {
      return isMultipleFiles ? t("Unable to upload files") : t("Unable to upload file");
    }
    return isMultipleFiles ? t("Failed To Upload Files") : t("Failed To Upload File");
  };

  const getModalDescription = () => {
    const isMultipleFiles = filesToBeUploaded.length > 1;

    if (props.addCommentTryAgain) {
      return isMultipleFiles ? t("The following files could not be uploaded:") : t("The following file could not be uploaded:");
    }
    return isMultipleFiles ? t("The below files could not be uploaded to your case.") : t("The below file could not be uploaded to your case.");
  };

  const renderFileStatusIcon = (index) => {
    if (fileSuccessAndError.length !== filesToBeUploaded.length) {
      return <span></span>;
    }

    if (fileSuccessAndError[index] === "true") {
      return <img className="fileResponseStyle" alt="tickMark" src={Tick}></img>;
    }

    return <img className="fileResponseStyle" alt="cautionMark" src={Caution}></img>;
  };

  const renderInvalidFileMessage = (index) => {
    if (fileSuccessAndError.length !== filesToBeUploaded.length) {
      return <span></span>;
    }
    if (fileSuccessAndError[index] === "true") {
      return <span></span>;
    }
    return (
      <span
        style={{
          marginLeft: "18px",
          fontWeight: "bold",
          color: "coral",
        }}
      >
        {t("Invalid file")}
      </span>
    );
  };

  return (
    <>
      {props.filesTryAgainModal && (
        <RedesignedModal
          opened={props.filesTryAgainModal}
          onClickClose={() => (disableCancelButton ? null : props.setFileTryAgainModal(false))}
          isScrollable={true}
          ModalAriaLabel="Add attachment try again modal"
          title={getModalTitle()}
        >
          <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="16px" marginTop="0" lineHeight="20px">
            {getModalDescription()}
          </TextWrapper>
          <Wrapper height={filesToBeUploaded.length > 3 && "12rem"} position="relative">
            {filesToBeUploaded.length !== 0 &&
              filesToBeUploaded.map((fileInfos, index) => (
                <div className="filesContainer" key={`${fileInfos.name}-${index}`} style={{ height: "auto" }}>
                  {attachmentLoaderSmall && (
                    <CustomLoader className="smallLoaderContainer">
                      <Loader className="insideLoader" active={attachmentLoaderSmall} fullscreen={false}></Loader>
                    </CustomLoader>
                  )}
                  {renderFileStatusIcon(index)}
                  <TextWrapper
                    fontStyle="normal"
                    fontWeight="400"
                    fontSize="14px"
                    marginBottom="0"
                    marginTop="0"
                    padding="10px 0 0 0"
                    lineHeight="20px"
                  >
                    {fileInfos.name}
                  </TextWrapper>
                  {renderInvalidFileMessage(index)}
                </div>
              ))}
            <Wrapper className="customised-modal-button-wrapper" style={{ bottom: "-2" }}>
              <CustomisedTertiaryButton
                id="add-attachment-cancel-button"
                size="large"
                secondary={true}
                disabled={disableCancelButton}
                buttonWidth={props.windowSize.width <= 480 ? "100%" : ""}
                onClick={() => {
                  props.setFileTryAgainModal(false);
                }}
              >
                {t("Cancel")}
              </CustomisedTertiaryButton>
              <CPButton
                id="add-attachment-tryagain-button"
                size="large"
                fontSize="0.875rem"
                disabled={disableCancelButton}
                boxButton={true}
                secondary={false}
                onClick={handleFileUploadAgain}
                fontPaddingLeft="0"
                fontPaddingRight="0"
              >
                {t("TRY AGAIN")}
              </CPButton>
            </Wrapper>
          </Wrapper>
        </RedesignedModal>
      )}
    </>
  );
};

const mapDispatchToProps = {
  setFileTryAgainModal: GlobalActions.setFileTryAgainModal,
  setFileTryAgainSuccess: GlobalActions.setFileTryAgainSuccess,
  getAllViewCaseDetails: viewCaseDetailsActions.getAllViewCaseDetails,
  setAttachmentStatusResponse: viewCaseDetailsActions.setAttachmentStatusResponse,
  setAttachmentName: viewCaseDetailsActions.setAttachmentName,
  setCaseNumberGlobal: GlobalActions.setCaseNumberGlobal,
  getActivity: viewCaseDetailsActions.getActivity,
};
const mapStateToProps = (state) => {
  return {
    filesTryAgainModal: state.ACCOUNT.filesTryAgainModal,
    fileTryAgainSuccess: state.ACCOUNT.fileTryAgainSuccess,
    caseIdGlobal: state.ACCOUNT.caseIdGlobal,
    windowSize: state.ACCOUNT.windowSize,
  };
};

AddAttachmentTryAgain.propTypes = {
  filesToBeUploaded: PropTypes.array,
  filesTryAgainModal: PropTypes.bool,
  setFileTryAgainModal: PropTypes.func,
  setFileTryAgainSuccess: PropTypes.func,
  setAttachmentStatusResponse: PropTypes.func,
  setAttachmentName: PropTypes.func,
  setCaseNumberGlobal: PropTypes.func,
  getActivity: PropTypes.func,
  addCommentTryAgain: PropTypes.bool,
  windowSize: PropTypes.object,
  addCommentCaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  caseIdGlobal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAttachmentTryAgain);
